module.exports = __webpack_public_path__ + "img/total_sales.1944832b.png";